<template>
  <div class="grid-stack-item org-jobs box">

    <job-logos :qrcode="false" :organisation="organisation"/>

    <div class="jobs">
      <job-item
        v-for="(job, index) in organisation.jobs"
        v-bind:job="job"
        v-bind:org_id="organisation.id"
        v-bind:index="index"
        v-bind:key="job.id"
      ></job-item>
    </div>
  </div>
</template>
<script>

  import JobItem from '@/components/jobs/JobItem';
  import JobLogos from '@/components/jobs/JobLogos';

  export default {

    name: 'JobList',

    created() {
    },

    data() {
      return {
        jobs: {
          data: [
            {
              attributes: {
                title: 'Loading data',
              },
            },
          ],
        },
      };
    },
    methods: {
      getJobs() {
        if (this.organisation.id !== null) {
          this.jobResource.get().then((response) => {
            this.jobs = response.data;
          });
        }
      },
    },

    props: ['organisation', 'qrcode', 'outJobs'],

    components: {
      JobItem,
      JobLogos,
    },

  };
</script>
<style lang="scss" rel="stylesheet/scss">

  @import "../../styles/variables";

  h2.title {
    color: $tamedia_black;
    padding: 0 0 0 0.5rem;
    font-size: 38px;
    border-left: solid 8px $tamedia_red;
    line-height: 2.5rem;

  }

  div.jobs.columns {
    margin: 0;
  }
  .org-jobs {
    margin: 0 0 0 0;
    min-width: 280px;
  }

  .box {
    background: rgba(255, 255, 255, 1);
  }

  .box:not(:last-child) {
    margin-bottom: 10px;
  }
  .grid-stack-item.org-jobs.box {
    min-width: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/jobs/JobList.vue